// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__bW9OZ","location":"Header_location__Dgn6i"};